import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Importfilecontent from '../sections/Addproduct/Importfilecontent'
import Quickbar from '../layouts/Quickbar';

class Importfile extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <Importfilecontent/>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Importfile;